/* global axios */
import ApiClient from './ApiClient';

class TalkviaProposalsAPI extends ApiClient {
  constructor() {
    super('talkvia_proposals', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, { talkvia_proposal: data });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  getById(id) {
    return axios.get(`${this.url}/${id}`);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { talkvia_proposal: data });
  }

  bulkUpdate(data) {
    return axios.post(`${this.url}/bulk_update`, data);
  }

  simulate(id) {
    return axios.post(`${this.url}/${id}/simulate`);
  }

  simulationDrafts(params = {}) {
    return axios.get(`${this.url}/simulation_drafts`, { params });
  }

  acceptSimulationDraft(data) {
    return axios.post(`${this.url}/accept_simulation_draft`, data);
  }
}

export default new TalkviaProposalsAPI();
